import ShopTheLook from '@components/media-text/components/shopTheLook/ShopTheLook'
import Placeholders from '@components/media-text/components/placeholders/Placeholders'
import styles from './Content.module.scss'
import { ContentProps } from './types'
import CTA from '@commons/cta/CTA.tsx'
import ModalTrigger from '@commons/enhanced-modal/ModalTrigger.tsx'

export default function Content({
    text = '',
    promotion_details = null,
    buttonPrimary = null,
    buttonSecondary = null,
    products = [],
    placeholders = [],
    campaign = {},
    hide_ctas = false,
    contrast,
    onOpenModal
}: ContentProps) {
    if (hide_ctas) {
        return <>{text && renderText(text)}</>
    }

    return (
        <>
            {text && renderText(text)}
            {products.length > 0 && <ShopTheLook />}
            {placeholders?.length > 0 && <Placeholders items={placeholders} />}
            {buttonPrimary &&
                renderButtons({
                    primaryCTA: buttonPrimary,
                    secondaryCTA: buttonSecondary,
                    campaign: campaign,
                    contrast: contrast
                })}

            {renderLink({
                promotion_details: promotion_details,
                onOpenModal: onOpenModal
            })}
        </>
    )
}

function renderText(text) {
    if (!text) {
        return null
    }

    const replacedText = text.replace(
        /<li>([^<>]*)<\/li>/g,
        '<li><nb-icon icon="24/symbol/check"></nb-icon>$1</li>'
    )

    return (
        <>
            <div className={`${styles['content']} t-sm-400`}>
                <p dangerouslySetInnerHTML={{ __html: replacedText }}></p>
            </div>
        </>
    )
}

function renderButton(args, campaign, index, contrast) {
    if (!args?.label) {
        return null
    }

    return (
        <>
            <CTA
                {...args}
                tracking_select_promotion={`LINK - ${index} - ${args?.label}`}
                campaign={campaign}
                contrast={contrast}
            />
        </>
    )
}

function renderButtons({ primaryCTA, secondaryCTA, campaign, contrast }) {
    return (
        <>
            <div className={styles['content-buttons']}>
                {primaryCTA
                    ? renderButton(primaryCTA, campaign, 1, contrast)
                    : null}
                {secondaryCTA
                    ? renderButton(secondaryCTA, campaign, 2, contrast)
                    : null}
            </div>
        </>
    )
}

function renderLink({ promotion_details, onOpenModal }) {
    if (promotion_details?.promo_link?.label) {
        return (
            <ModalTrigger
                onClick={() => {
                    onOpenModal(promotion_details)
                }}
                {...promotion_details.promo_link}
            />
        )
    }

    return null
}
